import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { trackEvent } from "../lib/api";

const CTABand = () => (
  <section className="relative overflow-hidden bg-brand-950 grain">
    <div className="absolute -right-24 -top-24 h-96 w-96 rounded-full bg-brand-600/30 blur-[120px]" aria-hidden="true" />
    <div className="absolute -bottom-32 -left-16 h-80 w-80 rounded-full bg-accent/20 blur-[110px]" aria-hidden="true" />
    <div className="container-x relative py-24 md:py-32">
      <Reveal>
        <span className="eyebrow text-accent">Start the conversation</span>
        <h2 className="mt-6 max-w-4xl font-heading text-3xl md:text-5xl font-semibold tracking-tight text-white text-balance">
          Planning a Healthcare Facility or Looking to Upgrade an Existing One?
        </h2>
        <p className="mt-6 max-w-2xl text-base md:text-lg leading-relaxed text-white/70">
          Tell us what you are planning. Our team can help you identify the equipment, infrastructure and support
          requirements for your healthcare project.
        </p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link
            to="/contact"
            data-testid="cta-discuss-project"
            onClick={() => trackEvent("consultation_request", { source: "cta_band" })}
            className="btn-accent"
          >
            Discuss Your Project <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to="/contact?intent=quote" data-testid="cta-request-quote" className="btn-ghost-light">
            Request a Quote
          </Link>
        </div>
      </Reveal>
    </div>
  </section>
);

export default CTABand;
